<template>
  <b-modal
    centered
    id="select-update-dialog"
    size="lg"
    modal-class="overflow-hidden"
    title="Thêm thành viên"
    static
    scrollable
    @hidden="onHidden"
    v-model="showModalUpdate"
  >
    <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              type="text"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              v-model.trim="search.keyWord"
            />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng kinh doanh"
              v-model="search.region"
              :options="Config.getSearch(optionRegion)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vị trí công việc"
              v-model="search.typeSale"
              :options="Config.getSearch(optionRole)"
            >
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="fetchData()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body px-20 row align-items-center" v-for="item in data" :key="item.id">
        <div class="col-md-1">
          <b-form-checkbox v-model="item.checked" @change="updateCheckDataPrevious(item.id)" />
        </div>
        <div class="col-md-11">
          <span>{{ item.name ?? '' }}</span
          ><span>{{ item.typeSale ? '- ' + joinArrayData(item.typeSale, optionRole) : '' }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          @change="onChangePage"
        />
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="confirmAddStaff"> Xác nhận </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-modal>
</template>
<script>
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        Config,
        showModalUpdate: false,
        showLoading: false,
        data: [],
        search: {
          page: 1,
          size: 20,
        },
        optionRegion: [],
        // optionComphase: Config.optionComphase,
        optionRole: [],
        pagination: {
          total: 0,
        },
        dataPrevious: [],
      }
    },
    created() {},
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      existsDataPreviousIds() {
        return this.dataPrevious.reduce((arr, item) => {
          arr.push(item.id)
          return arr
        }, [])
      },
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const bodySearch = {}
          for (const key in this.search) {
            if (this.search[key] && this.search[key] !== '0') {
              bodySearch[key] = this.search[key]
            }
          }

          const response = await StaffService.getList(bodySearch)
          if (response.code === 1000) {
            this.data = response.data.content
              ? response.data.content.map(el => {
                  el.checked = false
                  if (!this.existsDataPreviousIds.includes(el.id)) {
                    this.dataPrevious.push(el)
                  }
                  if (this.dataPrevious.length > 0) {
                    const checked = this.dataPrevious.find(
                      s => s.id === el.id && s.checked === true
                    )
                    if (checked) {
                      el.checked = true
                    }
                  }
                  return el
                })
              : []
            this.pagination.total = response.data.totalElements ? response.data.totalElements : 0
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      onHidden() {
        this.showModalUpdate = false
        this.resetForm()
      },
      resetForm() {
        this.data = {}
        this.search = {
          page: 1,
          size: 20,
        }
        this.dataPrevious = []
      },
      show(existsIds) {
        this.resetForm()
        this.showModalUpdate = true
        this.fetchData()
        this.getRegions()
        this.getTypeSale()
      },
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
      clearSearch() {
        this.search = {
          page: 1,
          size: 20,
        }
        ;(this.pagination = {
          total: 0,
        }),
          this.fetchData()
      },
      async getTypeSale() {
        try {
          const data = await CommonService.getTypeSale({})
          if (data.success) {
            this.optionRole = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
      confirmAddStaff() {
        const dataChecked = this.dataPrevious.filter(acc => acc.checked)
        this.$emit('addStaff', dataChecked)
        this.showModalUpdate = false
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
      updateCheckDataPrevious(id) {
        const index = this.dataPrevious.findIndex(s => s.id === id)
        if (index !== -1) {
          this.dataPrevious[index].checked = true
        }
      },
    },
  }
</script>
<style scoped></style>
